export default function (): void {
  const openCollapsible = (target: HTMLElement): void => {
    if (target.classList.contains('dca-collapsible-block__toggle')) {
      const parentEl = target.parentNode as HTMLElement

      if (parentEl.classList.contains('dca-collapsible-block--collapsed')) {
        target.click()
      }
    }
  }

  document.addEventListener('click', function (e) {
    const target = e.target as HTMLElement

    if (target.matches('.scroll-target')) {
      e.preventDefault()

      let targetHrefEl = null

      if (target.hasAttribute('href')) {
        targetHrefEl = document.getElementById(target.getAttribute('href')?.replace('#', '') as string)
      }

      if (target.hasAttribute('data-target')) {
        targetHrefEl = document.getElementById(target.getAttribute('data-target')?.replace('#', '') as string)
      }

      if (targetHrefEl) {
        const event = new CustomEvent('close-all-modals')
        document.body.dispatchEvent(event)

        targetHrefEl.scrollIntoView({
          block: 'start',
          inline: 'nearest',
        })

        if (target.classList.contains('open-collapsible')) {
          openCollapsible(targetHrefEl)
        }
      }
    }
  })
}
